import { gql } from '@apollo/client';

const equipmentCodeViewItem = gql`
  fragment EquipmentCodeViewItem on EquipmentCodeView {
    id
    hasBlocks
  }
`;

export const equipmentCodeFragments = {
  equipmentCodeItem: gql`
    ${equipmentCodeViewItem}
    fragment EquipmentCodeItem on EquipmentCode {
      id
      approvedBy
      approvedTime
      breakerPanelType
      budgetQty
      checkedBy
      checkedTime
      costCode
      equipments {
        id
      }
      defaultCableCodeId
      defaultGroundLocation
      defaultNumberOfCables
      description
      engineeringStatus
      isBreakerPanel
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      ownerId
      preparedBy
      preparedTime
      projectId
      revision
      stockCode
      stockCodeType
      tag
      unitPrice
      updatedBy
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      updatedTime
      equipmentCodeView {
        ...EquipmentCodeViewItem
      }
    }
  `,
};

export const CREATE_EQUIPMENT_CODE = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  mutation CreateEquipmentCode($createEquipmentCodeInput: CreateEquipmentCodeInput!) {
    createEquipmentCode(createEquipmentCodeInput: $createEquipmentCodeInput) {
      equipmentCode {
        ...EquipmentCodeItem
      }
      errors
    }
  }
`;

export const DELETE_EQUIPMENT_CODE = gql`
  mutation DeleteEquipmentCode($deleteEquipmentCodeInput: DeleteEquipmentCodeInput!) {
    deleteEquipmentCode(deleteEquipmentCodeInput: $deleteEquipmentCodeInput) {
      id
      errors
    }
  }
`;

export const UPDATE_EQUIPMENT_CODE = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  mutation UpdateEquipmentCode($updateEquipmentCodeInput: UpdateEquipmentCodeInput!) {
    updateEquipmentCode(updateEquipmentCodeInput: $updateEquipmentCodeInput) {
      equipmentCode {
        ...EquipmentCodeItem
      }
      errors
    }
  }
`;

export const UPDATE_EQUIPMENT_CODES = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  mutation UpdateEquipmentCodes($updateEquipmentCodesInput: [UpdateEquipmentCodeInput!]!) {
    updateEquipmentCodes(updateEquipmentCodesInput: $updateEquipmentCodesInput) {
      equipmentCodes {
        ...EquipmentCodeItem
        defaultCableCode {
          id
          tag
        }
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_EQUIPMENT_CODE_BY_ID = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  query EquipmentCodeById($id: ID!) {
    equipmentCodeById(id: $id) {
      ...EquipmentCodeItem
    }
  }
`;

export const GET_EQUIPMENT_CODES_BY_IDS = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  query EquipmentCodeByIds($ids: [ID!]!) {
    equipmentCodeByIds(ids: $ids) {
      ...EquipmentCodeItem
    }
  }
`;

export const ISSUE_EQUIPMENT_CODES = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  mutation IssueEquipmentCodes($issueEquipmentCodesInput: [IssueEquipmentCodeInput!]!) {
    issueEquipmentCodes(issueEquipmentCodesInput: $issueEquipmentCodesInput) {
      equipmentCodes {
        ...EquipmentCodeItem
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_EQUIPMENT_CODE_VIEW_STATS = gql`
  ${equipmentCodeViewItem}
  query EquipmentCodeViewStats($id: ID!) {
    equipmentCodeById(id: $id) {
      id
      equipmentCodeView {
        ...EquipmentCodeViewItem
      }
    }
  }
`;

export const SEARCH_EQUIPMENT_CODE = gql`
  ${equipmentCodeFragments.equipmentCodeItem}
  query SearchEquipmentCodes($searchInput: SearchInput!) {
    searchEquipmentCodes(searchInput: $searchInput) {
      items {
        ...EquipmentCodeItem
      }
    }
  }
`;
